import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";

// Core Components
import MDCButton from "../../core/MDCButton";

// Constants
import { QES_SIGNING_START } from "../../../constants/SigningProviderConstants";

const useStyles = makeStyles((theme) => ({
  vendorBanner: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "1rem",
    padding: "0.75rem 1rem",
    marginBottom: "1.5rem",
    width: "100%",
    background: theme.palette.MDCColors.white,
    border: `1px solid ${theme.palette.MDCColors.color21}`,
    borderRadius: "6px",
  },
  vendorTitle: {
    fontWeight: 600,
    fontSize: "0.875rem",
    color: theme.palette.MDCColors.textColor,
    marginBottom: "0.25rem",
    fontFamily: theme.palette.typography.fontFamily,
  },
  vendorSubtitle: {
    margin: 0,
    fontSize: "0.875rem",
    color: theme.palette.MDCColors.color18,
    fontFamily: theme.palette.typography.fontFamily,
  },
  // Banner button — override MDCButton width so it doesn't stretch
  vendorBannerBtn: {
    flexShrink: 0,
    "& button": {
      whiteSpace: "nowrap",
      minWidth: "unset !important",
    },
  },
}));

function ProviderBanner({
  provider,
  handleQESVendor,
  disabled,
  isComplete,
  isCompleteScreen,
}) {
  const { vendorBanner, vendorTitle, vendorSubtitle, vendorBannerBtn } =
    useStyles();

  return (
    <div className={vendorBanner}>
      <div>
        <div className={vendorTitle}>
          {QES_SIGNING_START.SELECTED_VENDOR_TITLE}:{" "}
          {provider?.name || provider?.displayName}
        </div>
        <p className={vendorSubtitle}>
          {QES_SIGNING_START.SELECTED_VENDOR_SUBTITLE}
        </p>
      </div>

      {!isCompleteScreen && (
        <div className={vendorBannerBtn}>
          <MDCButton
            variant="outlined"
            label={
              isComplete
                ? QES_SIGNING_START.DELETE_POA_BUTTON
                : QES_SIGNING_START.CANCEL_BUTTON
            }
            startIcon={<CloseIcon />}
            onClick={handleQESVendor}
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
}

ProviderBanner.propTypes = {
  provider: PropTypes.string.isRequired,
  handleQESVendor: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isComplete: PropTypes.bool,
  isCompleteScreen: PropTypes.bool,
};

ProviderBanner.defaultProps = {
  disabled: false,
  isComplete: false,
};

export default ProviderBanner;
